<template>
    <v-container>
        <!--v-layout align-center justify-center-->
        <v-layout align-center justify-center>
            <v-loading class="loading" v-model="loading" v-if="loading">
    
                <v-progress-circular persistent
                :size="70"
                :width="7"
                color="primary"
                indeterminate
                ></v-progress-circular>
        
            </v-loading>
            <v-flex xs12 sm8 md4>
                <!--v-card class="elevation-12"-->
                <v-card>
                    <v-toolbar dark color="primary">
                        <v-toolbar-title><a href="javascript:history.back()" class="voltar"><img class="imgVoltar" :src="imgVoltar"></a>Criação de Usuários <a @click="dialogUsuarios = true"><img class="imgDuvida" :src="imgDuvida"></a></v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>
                        <!--v-form ref="form" v-model="valid" lazy-validation-->
                        <v-form ref="form" v-model="valid" lazy-validation>
                            <h3>Credenciais</h3>

                            <v-card-text style="padding:0 0 0 0; width:100%"> 
                                <!--v-radio-group v-model="opt1"-->
                                <v-select
                                    :items="itemsPerfilUsuario2"
                                    item-value="value.perfilID"
                                    item-text="value.perfilName"
                                    return-object
                                    v-model="currentPerfilSelect"
                                ></v-select>
                                                                
                            </v-card-text>

                            <v-text-field v-if="currentPerfilSelect.value.perfilID != 7" prepend-icon="person" browser-autocomplete="new-email" name="email" label="Email" type="email"
                                          v-model="email" :rules="emailRules" data-cy="joinEmailField" required>
                            </v-text-field>
                            <v-text-field v-if="currentPerfilSelect.value.perfilID != 7" prepend-icon="lock" browser-autocomplete="new-password" name="password" label="Password"
                                          type="password" required v-model="password" :rules="passwordRules"
                                          data-cy="joinPasswordField">
                            </v-text-field>
                            <br /><br />
                            <h3>Dados complementares</h3>
                            <v-text-field name="nome" :rules="nomeRules" label="Nome completo" type="text"
                                          v-model="nome" data-cy="joinEmailField" required>
                            </v-text-field>

                            <v-text-field name="celular" label="Celular" type="text" placeholder="(##) #####-####" v-mask="'(##) #####-####'"
                                          v-model="celular" required>
                            </v-text-field>

                            <v-text-field name="dataNascimento" type="tel" v-mask="'##/##/####'" placeholder="DD/MM/YYYY" label="Data de nascimento"
                                          v-model="dataNascimento" required>
                            </v-text-field>

                            <v-text-field v-if="currentPerfilSelect.value.perfilID == 6" name="dataVencimentoMensal" type="tel" v-mask="'##'" placeholder="DD" label="Data de vencimento mensal"
                                          v-model="dataVencimentoMensal" required>
                            </v-text-field>
                            
                            <v-layout row wrap v-if="currentPerfilSelect.value.perfilID == 5 || currentPerfilSelect.value.perfilID == 4">
                                <v-flex xs10 sm10 md10>
                                    <v-card-text style="padding:0 0 0 0; width:100%"> 
                                        <!--v-radio-group row v-model="opt1"-->
                                        <v-select
                                            v-model="turmas"
                                            :items="itemsTurmas"
                                            label="Turmas"
                                            required
                                            ></v-select>
                                    </v-card-text>
                                </v-flex>
                                <v-flex xs2 sm2 md2>
                                    <v-btn fab dark color="green" text-xs-right @click="adicionarTurmasArray" class="adicionarItem btCirculo">
                                        <a>+</a>
                                    </v-btn>
                                    
                                </v-flex>
                                <div class="box-items-selecionados">
                                    <v-layout row wrap v-for="itemsTurmasSelecionada in itemsTurmasSelecionadas">
                                        <v-flex xs10 sm10 md10>{{ itemsTurmasSelecionada }}</v-flex>
                                        <v-flex xs2 sm2 md2><v-btn fab dark color="red" class="excluirItem btCirculo" text-xs-right @click="removerTurmasArray(itemsTurmasSelecionada)">-</v-btn></v-flex>
                                    </v-layout>
                                    
                                </div>
                            </v-layout>

                            <!-- <v-layout row wrap>
                                <v-flex xs10 sm10 md10>
                                    <v-flex xs12 sm12 md12>
                                        <v-card-text style="padding:0 0 0 0; width:100%"> 
                                            <v-select
                                                :items="itemsResponsaveis"
                                                item-value="responsavelSlug"
                                                item-text="responsavelName"
                                                return-object
                                                v-model="responsaveis"
                                                label="Responsáveis"
                                            ></v-select>
                                        </v-card-text>
                                    </v-flex><br />
                                </v-flex>
                                <v-flex xs2 sm2 md2>
                                    <v-btn fab dark color="green" text-xs-right @click="adicionarResponsaveisArray" class="adicionarItem btCirculo">
                                        <a>+</a>
                                    </v-btn>
                                    
                                </v-flex>
                                <div class="box-items-selecionados">
                                    <v-layout row wrap v-for="itemsResponsaveisSelecionado in itemsResponsaveisSelecionados">
                                        <v-flex xs10 sm10 md10>{{ itemsResponsaveisSelecionado }}</v-flex>
                                        <v-flex xs2 sm2 md2><v-btn fab dark color="red" class="excluirItem btCirculo" text-xs-right @click="removerResponsaveisArray(itemsResponsaveisSelecionado)">-</v-btn></v-flex>
                                    </v-layout>
                                    
                                </div>
                            </v-layout> -->
                            
                            <v-layout row wrap v-if="currentPerfilSelect.value.perfilID == 6">
                                <v-flex xs10 sm10 md10>
                                    <v-card-text style="padding:0 0 0 0; width:100%"> 
                                        <!--v-radio-group v-model="opt1"-->
                                        
                                            <v-select
                                                :items="itemsAlunos"
                                                item-value="alunoSlug"
                                                item-text="alunoName"
                                                return-object
                                                v-model="alunos"
                                                label="Alunos"
                                                required
                                                ></v-select>
                                        
                                    </v-card-text>
                                </v-flex>
                                <v-flex xs2 sm2 md2>
                                    <v-btn fab dark color="green" text-xs-right @click="adicionarAlunosArray" class="adicionarItem btCirculo">
                                        <a>+</a>
                                    </v-btn>
                                    
                                </v-flex>
                                <div class="box-items-selecionados">
                                    <v-layout row wrap v-for="itemsAlunosSelecionado in itemsAlunosSelecionados">
                                        <v-flex xs10 sm10 md10>{{ itemsAlunosSelecionado.alunoName }}</v-flex>
                                       <v-flex xs2 sm2 md2> <v-btn fab dark color="red" class="excluirItem btCirculo" text-xs-right @click="removerAlunosArray(itemsAlunosSelecionado)">-</v-btn></v-flex>
                                    </v-layout>
                                    
                                </div>
                            </v-layout>

                            <v-layout row wrap v-if="currentPerfilSelect.value.perfilID == 6">
                                <v-flex xs11 sm5>
                                    <v-switch
                                        v-model="autorizacao"
                                        :label="`Autorizado a buscar a criança?`"
                                    ></v-switch>
                                </v-flex>
                            </v-layout>

                            <br />
                            <label class="v-label theme--light">Foto do perfil:</label>
                            <!--input type="file" @change="onFileSelected" id="fileButton" /-->
                            <!--progress value="0" max="100" id="uploader">0</progress>
                            <br /><br /-->
                            
                            <!-- inicio - plugin compressor de imagem -->
                            <image-compressor class="compressor" :done="getFiles" :scale="scale" :quality="quality" ref="compressor"></image-compressor>

                            <div style="display:none" class="checkbox">
                            <input type="checkbox" v-model="originalSize">
                            <span>Responsive Image?</span>
                            </div>

                            <div style="display:none" class="input-group">
                            <label>Image Scale</label>
                            <input type="number" v-model="scale">
                            </div>

                            <div style="display:none" class="input-group">
                            <label>Image Quality</label>
                            <input type="number" v-model="quality">
                            </div>

                            <div class="image-info" v-if="img">
                                <b>Before: </b>
                                <span>{{ original.size }}</span>
                                <span class="separator"> | </span>
                                <b>After: </b>
                                <span>{{ compressed.size }}</span>
                            </div>

                            <div style="display: none" class="text-center" v-if="img">
                            <img v-if="img" src="" alt="" :style="{ maxWidth: originalSize ? '100%' : null }" :src="img">
                            <a :href="img" class="button" target="_blank">Download</a>
                            </div>
                            <b v-if="img">Preview da imagem: </b>
                            <div class="text-center imagem" v-if="img">
                                <img v-if="img" src="" alt="" :src="img">
                            </div>
                            <!-- Fim - plugin compressor de imagem -->
                            <!-- <input type="file" @change="onFileSelected" id="fileButton" />
                            <progress value="0" max="100" id="uploader">0</progress> -->
                            
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <!--v-btn color="primary" :disabled="!valid" @click="submit" data-cy="joinSubmitBtn">Cadastrar</v-btn-->
                        <v-btn color="primary" :disabled="!valid || !statusUpload" @click="submit" data-cy="joinSubmitBtn">Criar</v-btn>
                    </v-card-actions>
                </v-card>
            </v-flex>
        </v-layout>
        <v-dialog v-model="dialog" persistent max-width="290">
            <v-card>
                <v-card-title class="headline">{{tituloModal}}</v-card-title>
                <!--v-card-text>Let Google help apps determine location. This means sending anonymous location data to Google, even when no apps are running.</v-card-text-->
                <v-card-actions>
                <v-spacer></v-spacer>
                <!--v-btn color="green darken-1" flat @click="dialog = false">Disagree</v-btn-->
                <v-btn color="green darken-1" flat @click="closeModal">OK</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialogUpload" max-width="290">
            <v-card>
                <v-card-title class="headline">{{tituloModal}}</v-card-title>
                <!--v-card-text>Let Google help apps determine location. This means sending anonymous location data to Google, even when no apps are running.</v-card-text-->
                <v-card-actions>
                <v-spacer></v-spacer>
                <!--v-btn color="green darken-1" flat @click="dialog = false">Disagree</v-btn-->
                <v-btn color="green darken-1" flat @click="dialogUpload = false">OK</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialogUsuarios" persistent max-width="290">
            <v-card>
                <v-card-title class="headline">Perfis de usuários</v-card-title>
                <v-card-text>
                    <a class="closeModal" @click="dialogUsuarios = false">x</a>
                    <b>Perfil da Escola</b><br />
                    <span>É o único perfil que pode criar e excluir usuários, além disso, pode cadastrar conteúdo e visualizar o dashboard da escola.</span><br /><br />
                    <hr /><br />

                    <b>Perfil Administrativo</b><br />
                    <span>Pode cadastrar conteúdo e visualizar dashboard da escola.</span><br /><br />
                    <hr /><br />

                    <b>Perfil Administrativo/Professor</b><br />
                    <span>É um perfil de professor que também pode cadastrar conteúdos e visualizar o dashboard da escola. Além disso, tem a responsabilidade de cadastrar as informações dos alunos de sua turma.</span><br /><br />
                    <hr /><br />

                    <b>Perfil do Professor</b><br />
                    <span>É o perfil do professor, ter a responsabilidade de cadastrar as informações dos alunos de sua turma.</span><br /><br />
                    <hr /><br />

                    <b>Perfil dos Pais ou Responsáveis</b><br />
                    <span>Perfil que pode visualizar as informações de seus filhos.</span><br /><br />
                    <hr /><br />

                    <b>Perfil do Aluno</b><br />
                    <span>Esse perfil não tem acesso ao aplicativo, esse perfil é criado apenas para cadastrar as informações do aluno.</span><br /><br />

                </v-card-text>
                <v-card-actions>
                <v-spacer></v-spacer>
                <!--v-btn color="green darken-1" flat @click="dialog = false">Disagree</v-btn-->
                <v-btn color="green darken-1" flat @click="dialogUsuarios = false">Fechar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import db from './firebaseInit';
import firebase,{ storage } from 'firebase';

import {mask} from 'vue-the-mask'

import { userProperties } from '@/global.js'

import imageCompressor from 'vue-image-compressor' // https://vuejsfeed.com/blog/compress-image-files-with-vue-2-image-compressor

import imgVoltar from '../assets/ic-voltar.png';
import imgDuvida from '../assets/ic-duvida.png';

export default {
    name: 'Cadastro-Usuarios-Adicionar',
    directives: {mask},
    data() {
        return {
            imgVoltar: imgVoltar,
            imgDuvida: imgDuvida,
            // Dados do compressor de imagens - Inicio 
            dialogUpload: false,
            img: "",
            scale: 100,
            quality: 50,
            originalSize: true,
            original: {},
            compressed: {},
            tresVezes: 0,
            // Dados do compressor de imagens - Fim 

            autorizacao: true,
            valid: false,
            nome: '',
            email: '',
            password: '',
            perfil: '0',
            escolaID: 0,
            dataNascimento: null,
            dataVencimentoMensal: null,
            celular: null,
            dialog: false,
            dialogUsuarios: false,
            loading: false,
            slug: this.slug,
            extensao : null,
            statusUpload: false,
            tituloModal: "Usuário criado com sucesso!",
            turmas: '',
            itemsTurmas: [],
            itemsTurmasSelecionadas: [],            
            itemsResponsaveisSelecionados: [],
            responsaveis: {
                    // alunoSlug: 1,
                    // alunoName: 'Alice'
            },
            itemsResponsaveis: [
                // {
                //         alunoSlug: 0,
                //         alunoName: 'Laura'
                // },
                // {
                //         alunoSlug: 1,
                //         alunoName: 'Alice'
                // }
            ],
            itemsAlunos: [],
            alunos: {
                    // alunoSlug: 1,
                    // alunoName: 'Alice'
            },
            itemsAlunos: [
                // {
                //         alunoSlug: 0,
                //         alunoName: 'Laura'
                // },
                // {
                //         alunoSlug: 1,
                //         alunoName: 'Alice'
                // }
            ],
            alunoSlug: null,
            itemsAlunosSelecionados: [],
            itemsPerfilUsuario2: [
                {
                    value: {
                        perfilID: 3,
                        perfilName: 'Administrativo'
                    },
                    text: 'Administrativo'
                },
                {
                    value: {
                        perfilID: 4,
                        perfilName: 'Administrativo/Professor'
                    },
                    text: 'Administrativo/Professor'
                },
                {
                    value: {
                        perfilID: 5,
                        perfilName: 'Professor'
                    },
                    text: 'Professor'
                },
                {
                    value: {
                        perfilID: 6,
                        perfilName: 'Responsável'
                    },
                    text: 'Responsável'
                },
                {
                    value: {
                        perfilID: 7,
                        perfilName: 'Aluno'
                    },
                    text: 'Aluno'
                }
            ],
            currentPerfilSelect: {
                value: {
                    perfilID: 3,
                    perfilName: 'Administrativo'
                }
            },
            nomeRules: [
                v => !!v || 'Nome é obrigatório',
                v =>
                    v.length >= 4 ||
                    'A senha deve ter mais de 3 characteres'
            ],
            perfilUsuario: '',
            itemsPerfilUsuario: [
                //{id: 1, name: 'Administrador'}, // Pode criar usuários do tipo escola somente. Não cria outros tipos de usuarios.
                //{id: 2, name: 'Escola'}, // Somente esse perfil cria os perfis de usuários abaixo
                {id: 3, name: 'Administrativo'}, // Pode criar os conteúdos mas não fica atrelado a uma turma
                {id: 4, name: 'Administrativo/Professor'}, // Pode criar conteúdos e fica atrelado a uma turma
                {id: 5, name: 'Professor'}, // Fica atrelado a uma turma mas não pode criar conteúdos
                {id: 6, name: 'Responsável'}, // Pode comentar postagens, usar chat, e ver relatório dos seus alunos atrelados
                {id: 7, name: 'Aluno'} // Não faz login no sistema, não precisa nem criar usuário no auth do Firebase, apenas no banco de dados
            ],
            emailRules: [
                v => !!v || 'E-mail é obrigatório',
                v => /.+@.+/.test(v) || 'E-mail deve ser válido.'
            ],
            passwordRules: [
                v => !!v || 'Senha obrigatória',
                v =>
                    v.length >= 7 ||
                    'A senha deve ter mais de 6 characteres'
            ]
        };
    },
    components: { imageCompressor },
    methods: { // ####################### Criar parte que criar documentos collections de cada escola ao realizar primeiro login do usuario Escola
        setProfile(){
           
           db.collection('usuarios').add({
                nome: this.nome,
                email: this.email,
                perfil: this.currentPerfilSelect.value.perfilID,
                escolaID: userProperties.escolaID,
                slug: this.slug,
                extensao: this.extensao,
                turmas: this.itemsTurmasSelecionadas,
                responsaveis: this.itemsResponsaveisSelecionados,
                alunos: this.itemsAlunosSelecionados,
                celular: this.celular,
                dataNascimento: this.dataNascimento,
                dataVencimentoMensal: this.dataVencimentoMensal,
                tokenFMC: null,
                autorizacao: this.autorizacao
            })
            .then(docRef => {
                console.log('Document written with ID: ', docRef.id);
                //this.$router.push(`/${slug}/success`)
                this.loading = false
                this.dialog = true
                
            })
            .catch(function (error) {
                this.loading = false
                console.log('Error adding document: ', error);
                console.log("Erro no envio dos dados. Tente novamente mais tarde!")
            })

            
        },
        closeModal(){
            this.$router.push(`/Cadastro-Usuarios-Listagem`);
        },
        adicionarTurmasArray(){
            if(this.turmas != ""){
                this.itemsTurmasSelecionadas.push(this.turmas);
        
                // Remove itens repetidos do array
                var groupsOfResult = [];

                groupsOfResult = this.itemsTurmasSelecionadas.filter(function (a) {
                    return !this[JSON.stringify(a)] && (this[JSON.stringify(a)] = true);
                }, Object.create(null))

                this.itemsTurmasSelecionadas = groupsOfResult;
            }

            this.reinderizar = true;
            //console.log(this.turmas);
            console.log(this.itemsTurmasSelecionadas);
        },
        removerTurmasArray(value) {
            console.log(value);
            //var index = 0;
            var atualizarTurmasSelecionadas = [];

            this.itemsTurmasSelecionadas.forEach(function(item){
                console.log(item);
                if(value != item){
                    atualizarTurmasSelecionadas.push(item);
                }
                //index = index + 1;
            });
            this.itemsTurmasSelecionadas = atualizarTurmasSelecionadas;
        },
        adicionarResponsaveisArray(){
            if(this.responsaveis != ""){
                this.itemsResponsaveisSelecionados.push(this.responsaveis);
        
                // Remove itens repetidos do array
                var groupsOfResult = [];

                groupsOfResult = this.itemsResponsaveisSelecionados.filter(function (a) {
                    return !this[JSON.stringify(a)] && (this[JSON.stringify(a)] = true);
                }, Object.create(null))

                this.itemsResponsaveisSelecionados = groupsOfResult;
            }

            this.reinderizar = true;
            //console.log(this.turmas);
            console.log(this.itemsResponsaveisSelecionados);
        },
        removerResponsaveisArray(value) {
            console.log(value);
            //var index = 0;
            var atualizarResponsaveisSelecionados = [];

            this.itemsResponsaveisSelecionados.forEach(function(item){
                console.log(item);
                if(value != item){
                    atualizarResponsaveisSelecionados.push(item);
                }
                //index = index + 1;
            });
            this.itemsResponsaveisSelecionados = atualizarResponsaveisSelecionados;
        },
        adicionarAlunosArray(){
            if(this.alunos != ""){
                this.itemsAlunosSelecionados.push(this.alunos);
        
                // Remove itens repetidos do array
                var groupsOfResult = [];

                groupsOfResult = this.itemsAlunosSelecionados.filter(function (a) {
                    return !this[JSON.stringify(a)] && (this[JSON.stringify(a)] = true);
                }, Object.create(null))

                this.itemsAlunosSelecionados = groupsOfResult;
            }

            this.reinderizar = true;
            //console.log(this.turmas);
            console.log(this.itemsAlunosSelecionados);
        },
        removerAlunosArray(value) {
            console.log(value);
            //var index = 0;
            var atualizarAlunosSelecionados = [];

            this.itemsAlunosSelecionados.forEach(function(item){
                console.log(item);
                if(value != item){
                    atualizarAlunosSelecionados.push(item);
                }
                //index = index + 1;
            });
            this.itemsAlunosSelecionados = atualizarAlunosSelecionados;
        },
        submit() {
            this.tituloModal = "Upload da imagem realizado com sucesso!"
            if(userProperties.escolaID != null){
                if (this.$refs.form.validate() && this.statusUpload == true) {
                    this.loading = true;
                    if(this.currentPerfilSelect.value.perfilID != 7){
                        this.$store.dispatch('userJoin', {
                            email: this.email,
                            password: this.password
                        })
                        .then(data => {
                            console.log('Login e senha criados com sucesso.');
                            this.loading = false
                            this.setProfile();
                        })
                        .catch(function (error) {
                            this.loading = false
                            console.log('Erro ao criar login e senha ', error);
                        })
                    }
                    else{
                        this.setProfile();
                    }
                }
                if (this.$refs.form.validate() && this.statusUpload == false) {
                    alert("Por favor, faça o upload da foto do perfil do usuário")
                }
            }
            else{
                alert("Sua sessão expirou, você será redirecionado para reautenticar!");
                this.$router.push(`/`);
            }
        },
        generateUUID () {
          let d = new Date().getTime()
          let uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            let r = (d + Math.random() * 16) % 16 | 0
            d = Math.floor(d / 16)
            return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16)
          })
          return uuid
        },
        perfilUsuarioID(e) {
            if(e.target.options.selectedIndex > -1) {
                console.log(e.target.options[e.target.options.selectedIndex].value)
                this.perfil = e.target.options[e.target.options.selectedIndex].value
            }
        },   
        // onFileSelected(event){
        //     this.loading = true;
        //     console.log(event);
        //     var file = event.target.files[0]
        //     var filename = event.target.files[0].name
            
        //     // Recupera imagem do storage
        //     var storageRef = firebase.storage().ref('profile/'+this.slug+"."+filename.toString().split(".")[1])
        //     this.extensao = filename.toString().split(".")[1];
        //     var task = storageRef.put(file)
        //     var that = this;
        //     task.on('state_changed',
        //         function progress(snapshot){
        //             var percentage = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        //             uploader.value = percentage;
        //             that.loading = false;
        //         },
        //         function error(err){
        //             alert("Error on upload. Check if image size is less than 900KB");
        //             that.statusUpload = false;
        //             that.loading = false;
        //         },
        //         function complete(){
        //             that.extensao = filename.toString().split(".")[1];
        //             that.statusUpload = true;
        //             alert("Upload successful!");
        //             that.loading = false;
        //         }
        //     )
        // }
        upload () {
            let compressor = this.$refs.compressor.$el
            compressor.click()
        },
        getFiles(obj){
            this.tresVezes = this.tresVezes + 1; // gambiarra do bug de executar 3 vezes
            

            this.img = obj.compressed.blob
            this.original = obj.original
            this.compressed = obj.compressed
            var escala = 0;
            var qualidade = 0;

            if(Number(obj.original.size.split(" ")[0]) > 4000){
                escala = 40;
                qualidade = 60;
            }
            else if(Number(obj.original.size.split(" ")[0]) > 3000 && Number(obj.original.size.split(" ")[0]) <= 4000){
                escala = 55;
                qualidade = 60;
            }
            else if(Number(obj.original.size.split(" ")[0]) > 2000 && Number(obj.original.size.split(" ")[0]) <= 3000){
                escala = 70;
                qualidade = 70;
            }
            else if(Number(obj.original.size.split(" ")[0]) > 1000 && Number(obj.original.size.split(" ")[0]) <= 2000){
                escala = 80;
                qualidade = 70;
            }
            else if(Number(obj.original.size.split(" ")[0]) > 500 && Number(obj.original.size.split(" ")[0]) <= 1000){
                escala = 90;
                qualidade = 80;
            }
            else{
                escala = 100;
                qualidade = 90;
            }

            this.scale = escala;
            this.quality = qualidade;
            //console.log(obj);
            this.loading = true;
            //console.log(event);
            if(this.tresVezes >= 2){
                this.tresVezes = 0;
                
                
                var file = obj.compressed.file

                var imageURL = obj.compressed.blob;
                
                var metadata = { contentType: 'image/jpeg'};
                //var metadata = { contentType: obj.original.type};
                var getFileBlob = function (url, cb) {
                    var xhr = new XMLHttpRequest();
                    xhr.open("GET", url);
                    xhr.responseType = "blob";
                    xhr.addEventListener('load', function() {
                        cb(xhr.response);
                    });
                    xhr.send();
                };
                //var uploadToStorage = (imageURL) => {

                    getFileBlob(imageURL, blob =>{
                        var filename = obj.compressed.file.name;
                        this.extensao = filename.toString().split(".")[1];
                        //this.scale = 40
                        
                        firebase.storage().ref().child('profile/'+this.slug+"."+filename.toString().split(".")[1]).put(blob, metadata)
                            .then(snapshot => {
                                this.loading = false
                                this.dialogUpload = true
                                this.tituloModal = "Upload da imagem realizado com sucesso!"
                                this.statusUpload = true;
                            })
                            .catch( (error) => {
                                this.loading = false
                                this.dialogUpload = true
                                this.tituloModal = "Erro ao realizar upload da imagem. Tente novamente!"
                            })
                    })   
            }
      }
        
    },
    mounted() {
    // verificiar perfil logado
    console.log(userProperties.perfil);
    if(userProperties.perfil != 2){
        alert("Acesso negado!");
        this.$router.push(`/?redirect=`+window.location.pathname)
    }

    const slug = this.generateUUID()
    this.slug = slug;
       
       // Preenche select/combo de turmas 
       db.collection("turmas").where("escolaID", "==", userProperties.escolaID)
        
        .get()
        .then((querySnapshot) => {
            querySnapshot.forEach(doc => {
                // doc.data() is never undefined for query doc snapshots
                //console.log(doc.id, " => ", doc.data());                    
                let customObj = doc.data()
                this.itemsTurmas.push(customObj.nome);
            });
        });

        // Preenche select/combo de responsaveis
        db.collection("usuarios").where("escolaID", "==", userProperties.escolaID).where("perfil", "==", 6)
        .get()
        .then((querySnapshot) => {
            querySnapshot.forEach(doc => {
                // doc.data() is never undefined for query doc snapshots
                //console.log(doc.id, " => ", doc.data());                    
                let customObj = doc.data()
                this.itemsResponsaveis.push({"responsavelName": customObj.nome, "responsavelSlug": customObj.slug});
            });
        });

        // Preenche select/combo de alunos
        db.collection("usuarios").where("escolaID", "==", userProperties.escolaID).where("perfil", "==", 7)
        .get()
        .then((querySnapshot) => {
            querySnapshot.forEach(doc => {
                // doc.data() is never undefined for query doc snapshots
                //console.log(doc.id, " => ", doc.data());                    
                
                let customObj = doc.data()                
                this.itemsAlunos.push({"alunoName": customObj.nome, "alunoSlug": customObj.slug});

                
            });
        });
       //alert(userProperties.perfil);
       //userProperties.perfil = "test2";
    }
};
</script>

<style scoped>
    .loading{
        position: absolute;
        top:20%;
        left:48%;
        z-index: 2;
    }

    .btCirculo{
        height: 30px;
        width: 30px;
    }

    .btCirculo a{
        color:#fff;
    }

    progress{
        width:100%;
        margin-top: 6px;
    }

    label.v-label.theme--light{
        margin-bottom: 6px;
        display: block
    }

    .adicionarItem.btCirculo{
        position: relative;
        top: 12px;
        left: 5px;
    }

    .excluirItem.btCirculo{
        position: relative;
        left: 5px;
        top:-10px;
    }

    .box-items-selecionados{
        background: silver;
        width: 100%;
        padding: 20px 5px 5px 10px;
    }

    .container{
        padding: 0 0 !important;
    }

    .imagem img{
        width: 100%;
        margin-top: 8px;
    }

    .v-toolbar__title{
        width: 100% !important;
    }
    
    .imgDuvida{
        float: right;
        margin-top: 4px;
    }

    a.closeModal{
        color:#000;
        position: absolute;
        top: 5px;
        right: 12px;
    }

</style>
